module.exports = __webpack_public_path__ + "img/bg-v1-blurred.ad0ffe18.jpg";